import { render, staticRenderFns } from "./type-warranty-field.vue?vue&type=template&id=63bf795d&scoped=true"
import script from "./type-warranty-field.vue?vue&type=script&setup=true&lang=ts"
export * from "./type-warranty-field.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63bf795d",
  null
  
)

export default component.exports